<template>
  <div class="page-password">
    <div class="page-header">
      <h2>{{ type === 'newChange' ? '修改会员密码' : type === 'change' ? '修改密码' : '设置密码' }}</h2>
    </div>
    <div class="page-body">
      <change v-if="['change', 'newChange'].includes(type)" :type="type" :loginName="loginName" :cid="cid"></change>
      <new v-if="type === 'new'"></new>
    </div>
    <template v-if="type === 'newChange'">
      <div class="page-footer">
        <div class="mod-tip">
          <a-icon type="exclamation-circle" theme="filled" /><a @click="toForgetPassword">忘记密码</a>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-footer" v-if="type === 'change'">
        <div class="mod-tip" v-if="userType === 0">
          <a-icon type="exclamation-circle" theme="filled" />若忘记原始密码，您可以使用 <router-link to="/authenticate?type=password">线上实名认证方式</router-link> 修改密码，或致电{{ app.name }}客服热线{{ app.hotline }}协助您找回密码。
        </div>
        <div class="mod-tip" v-else>
          <a-icon type="exclamation-circle" theme="filled" />若忘记原始密码，您可以致电{{ app.name }}客服热线{{ app.hotline }}协助您找回密码。
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import queryString from 'query-string'
import Change from './components/Change'
import New from './components/New'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      type: 'newChange',
      userType: 0,
      app: null,
      loginName: '',
      cid: ''
    }
  },
  created () {
    const params = queryString.parse(location.search)
    this.type = params.type || 'newChange'
    this.cid = params.cid || ''
    if (params.loginName) {
      this.loginName = decodeURIComponent(params.loginName)
    }
    const userInfo = this.$ls.get('USER_CENTER_INFO')

    if (userInfo) {
      this.userType = userInfo.userType
    }

    this.app = fromApp()
  },
  methods: {
    toForgetPassword (e) {
      e.preventDefault()
      window.location.href = 'https://ffp.hnair.com/FFPClub/member/getPassword'
    }
  },
  components: {
    Change,
    New
  }
}
</script>
